import { userSelectors } from '../../../actions/user/redux/selectors';
import { Avatar, Box, Typography, useAppSelector } from '../../../base';
import UserManagementMenu from './UserManagementMenu';

const UserPreview = () => {
    const myUser = useAppSelector(userSelectors.getMyUser);
    const userFullName = `${myUser?.firstName || ''} ${myUser?.lastName || ''}`;

    return (
        <Box display="flex" alignItems="center" flexDirection="row">
            <Avatar
                name={userFullName}
                src={myUser?.profilePicture}
                sx={{ height: '55px', width: '55px' }}
            />
            <Box
                flex={1}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                marginInlineStart={2}
            >
                <Box display="flex" alignItems="center">
                    <>
                        <Typography
                            variant="h5"
                            component="span"
                            marginInlineEnd={1}
                        >
                            {userFullName}
                        </Typography>
                        <UserManagementMenu />
                    </>
                </Box>
                <Typography variant="subtitle2">
                    {myUser?.email || ''}
                </Typography>
            </Box>
        </Box>
    );
};

export default UserPreview;
